import {
  ConfirmationModal,
  ConfirmationModalContent,
  ConfirmationButtonContainer,
  ConfirmationModalNo,
  ConfirmationModalYes,
} from './confirmation-popup.styles';

export interface ConfirmationPopupProps {
  onButtonClicked: (action: string) => void;
  showPopup: boolean;
  popupMsg: string;
  yesText?: string;
  noText?: string;
  closeText?: string;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = (confirmationPopupProps) => {
  const { onButtonClicked, showPopup, popupMsg, yesText, noText, closeText } = confirmationPopupProps;

  return (
    <ConfirmationModal visible={showPopup} onClose={() => onButtonClicked('close')}>
      <ConfirmationModalContent>{popupMsg}</ConfirmationModalContent>
      <ConfirmationButtonContainer>
        {noText ? <ConfirmationModalNo onClick={() => onButtonClicked('no')}>{noText}</ConfirmationModalNo> : <></>}
        {yesText ? (
          <ConfirmationModalYes onClick={() => onButtonClicked('yes')}>{yesText}</ConfirmationModalYes>
        ) : (
          <></>
        )}
        {closeText ? (
          <ConfirmationModalYes onClick={() => onButtonClicked('close')}>{closeText}</ConfirmationModalYes>
        ) : (
          <></>
        )}
      </ConfirmationButtonContainer>
    </ConfirmationModal>
  );
};

export default ConfirmationPopup;
